import { useCallback } from 'react'
import { useAppDispatch } from 'states/hooks'
import { useAiAssistantService } from '@crew/states'

/**
 * AIアシスタント - スレッド表示
 */
export const useAiAssistantThread = () => {
  // Sliceの操作を行うためのServiceを取得
  const dispatch = useAppDispatch()
  const aiAssistantService = useAiAssistantService(dispatch)

  // スレッド表示を解除する(トピックIDをリセット)
  const resetInThread = useCallback(() => {
    // スレッド表示を解除するためトピックIDをリセットする
    aiAssistantService.resetCurrentChatThread()
  }, [aiAssistantService])

  return {
    resetInThread,
  }
}
